export default {
  title: "Gästeliste",
  description: "Verwalten Sie Ihre Hochzeitsgäste",
  subtitle: "Verwalten Sie Ihre Gästeliste und Einladungen",
  addGuest: "Gast hinzufügen",
  editGuest: "Gast bearbeiten",
  deleteGuest: "Gast löschen",
  guestDeleted: "Gast erfolgreich gelöscht",
  guestCreated: "Gast erfolgreich erstellt",
  guestUpdated: "Gast erfolgreich aktualisiert",
  noGuests: "Keine Gäste gefunden",
  totalGuests: "{{count}} Gäste",
  confirmed: "{{count}} Bestätigt",
  declined: "{{count}} Abgelehnt",
  pending: "{{count}} Ausstehend",
  search: "Gäste suchen",
  addFirstGuest: "Fügen Sie Ihren ersten Gast hinzu, um zu beginnen",
  children: "Kinder",
  teens: "Jugendliche",
  cancel: "Abbrechen",

  filters: {
    title: "Filter",
    clear: "Filter löschen",
    status: {
      label: "Status",
      all: 'Alle',
      confirmed: 'Bestätigt',
      pending: 'Ausstehend',
      declined: 'Abgelehnt',
    },
    category: "Kategorie",
    ageGroup: "Altersgruppe",
    table: "Tisch",
    all: "Alle",
    reset: "Zurücksetzen",
    resetFilters: "Filter zurücksetzen",
    events: {
      label: 'Veranstaltungen',
      all: 'Alle',
      ceremony: 'Zeremonie',
      reception: 'Empfang',
      both: 'Beide',
      allEvents: 'Alle Veranstaltungen',
    },
    relation: "Beziehung",
    side: "Seite",
    apply: "Anwenden",
    guestsearch: "Gast suchen",
    previous: "Zurück",
    next: "Weiter",
    tableAssigned: "Tisch zugewiesen",
    group: {
      label: 'Gruppe',
      all: 'Alle',
      family: 'Familie',
      friends: 'Freunde',
      colleagues: 'Kollegen',
      other: 'Sonstige',
    },
    statusOptions: {
      all: 'Alle',
      confirmed: 'Bestätigt',
      pending: 'Ausstehend',
      declined: 'Abgelehnt',
    }
  },

  status: {
    pending: "Ausstehend",
    confirmed: "Bestätigt",
    declined: "Abgelehnt",
    tentative: "Vorläufig",
    maybe: "Vielleicht",
    invited: "Eingeladen",
    notInvited: "Nicht eingeladen",
    "guests.status.pending": "Ausstehend"
  },

  form: {
    title: "Gästedetails",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    address: "Adresse",
    status: "Status",
    category: "Kategorie",
    ageGroup: "Altersgruppe",
    dietaryRestrictions: "Ernährungseinschränkungen",
    notes: "Notizen",
    plusOne: "Begleitung",
    table: "Tisch",
    side: "Seite",
    relation: "Beziehung",
    specialRequirements: "Besondere Anforderungen",
    children: "Kinder",
    submit: "Speichern",
    cancel: "Abbrechen",
    errors: {
      firstNameRequired: "Vorname ist erforderlich",
      lastNameRequired: "Nachname ist erforderlich",
      emailInvalid: "Ungültige E-Mail-Adresse"
    }
  },

  categories: {
    bride_groom: "Brautpaar",
    family_close: "Enge Familie",
    family_extended: "Erweiterte Familie",
    witness: "Trauzeuge",
    honor_party: "Ehrengäste",
    friend_close: "Enger Freund",
    friend: "Freund",
    colleague: "Kollege",
    acquaintance: "Bekannter",
    other: "Sonstige"
  },

  groups: {
    family: "Familie",
    friends: "Freunde",
    colleagues: "Kollegen",
    other: "Sonstige"
  },

  ageGroups: {
    child: "Kind",
    teen: "Jugendlicher",
    adult: "Erwachsener",
    senior: "Senior"
  },

  import: {
    title: "Gäste importieren",
    description: "Importieren Sie Ihre Gästeliste aus einer CSV-Datei",
    template: "Vorlage herunterladen",
    upload: "Datei hochladen",
    processing: "Verarbeitung...",
    success: "{{count}} Gäste erfolgreich importiert",
    error: "Fehler beim Importieren der Gäste",
    formatError: "Ungültiges Dateiformat",
    instructions: "Laden Sie die Vorlage und Dokumentation herunter, um das Importformat zu verstehen. Wenn Ihre Datei bereit ist, wählen Sie sie zum Importieren aus.",
    downloadTemplate: "Vorlage herunterladen",
    downloadExcelTemplate: "Excel-Vorlage herunterladen",
    downloadCsvTemplate: "CSV-Vorlage herunterladen",
    downloadDocumentation: "Dokumentation herunterladen",
    selectFile: "Datei auswählen",
    importButton: "Importieren",
    preview: {
      summary: '{{valid}} gültige Zeilen von {{total}} ({{errors}} Fehler)',
      toggleDetails: 'Fehlerdetails anzeigen',
      rowNumber: 'Zeile {{row}}',
      retry: 'Mit einer anderen Datei wiederholen'
    },
    errors: {
      title: "Importfehler",
      invalidFileType: "Die Datei muss im CSV- oder Excel-Format sein",
      parseError: "Fehler beim Lesen der Datei",
      excelParseError: "Fehler beim Lesen der Excel-Datei",
      fileReadError: "Fehler beim Lesen der Datei",
      importFailed: "Import fehlgeschlagen",
      noValidGuests: "Keine gültigen Gäste in der Datei gefunden",
      validationErrors: "{{count}} Validierungsfehler gefunden:{{details}}",
      missingHeaders: "Fehlende erforderliche Spalten: {{headers}}",
      missingFirstName: "Vorname ist erforderlich",
      missingLastName: "Nachname ist erforderlich",
      invalidStatus: "Ungültiger Status: {{status}}",
      invalidCategory: "Ungültige Kategorie: {{category}}",
      invalidSide: "Ungültige Seite: {{side}}",
      invalidRelation: "Ungültige Beziehung: {{relation}}",
      invalidAgeGroup: "Ungültige Altersgruppe: {{ageGroup}}",
      invalidVip: "VIP-Wert muss 'true' oder 'false' sein",
      invalidPlusOne: "+1-Wert muss 'true' oder 'false' sein",
      invalidChildrenCount: "Anzahl der Kinder muss eine ganze Zahl sein",
      invalidTeenCount: "Anzahl der Jugendlichen muss eine ganze Zahl sein",
      missingPlusOneInfo: "Informationen zur Begleitung sind unvollständig",
      invalidEmail: "E-Mail-Adresse ist ungültig"
    }
  },

  export: {
    title: "Gäste exportieren",
    description: "Exportieren Sie Ihre Gästeliste als CSV",
    button: "Exportieren",
    success: "Gästeliste erfolgreich exportiert"
  },

  seatingPlan: {
    title: "Sitzplan",
    generate: "Sitzplan generieren",
    tables: "Tische",
    unassigned: "Nicht zugewiesene Gäste",
    capacity: "Kapazität",
    save: "Plan speichern",
    saveSuccess: "Sitzplan erfolgreich gespeichert",
    honorTable: "Ehrentisch",
    table: "Tisch {{number}}",
    config: "Konfiguration",
    honorTableCapacity: "Kapazität Ehrentisch",
    standardTableCapacity: "Kapazität Standardtische",
    numberOfTables: "Anzahl der Tische",
    honorTableSide: "Seite des Ehrentisches",
    options: "Optionen",
    prioritizeFamily: "Familie priorisieren",
    keepGroupsTogether: "Gruppen zusammenhalten",
    balanceTables: "Tische ausgleichen",
    separateConflicts: "Konflikte trennen",
    backToConfig: "Zurück zur Konfiguration",
    both: "Beide",
    bride: "Braut",
    groom: "Bräutigam",
    configTitle: "Sitzplan-Konfiguration",
    venueCapacity: "Veranstaltungsort-Kapazität",
    guestStats: "Gästestatistiken",
    tableCapacities: "Tischkapazitäten",
    totalCapacity: "Gesamtkapazität",
    remainingSeats: "Verbleibende Plätze",
    placementOptions: "Platzierungsoptionen",
    avoidConflicts: "Konflikte vermeiden",
    prioritizeHarmonies: "Harmonien priorisieren",
    keepFamiliesTogether: "Familien zusammenhalten",
    balanceAgeGroups: "Altersgruppen ausgleichen",
    specialTables: "Spezielle Tische",
    childrenTableCapacity: "Kapazität Kindertisch",
    teenTableCapacity: "Kapazität Jugendtisch",
    stats: "Statistiken",
    totalGuests: "Gesamtgäste",
    children: "Kinder",
    teens: "Jugendliche",
    generateSuccess: "Sitzplan erfolgreich generiert",
    generateError: "Fehler bei der Generierung des Sitzplans",
    saveError: "Fehler beim Speichern des Sitzplans",
    load: "Einen Plan laden",
    loadSaved: "Gespeicherte Pläne",
    separateFamilies: "Familien trennen",
    mixSidesForSingles: "Seiten für Singles mischen",
    separateFamiliesDesc: "Versucht, Paare aus verschiedenen Familien an getrennten Tischen zu platzieren",
    mixSidesForSinglesDesc: "Fördert das Mischen der Seiten (Braut/Bräutigam) für einzelne Gäste",
    balanceTablesDesc: "Gleicht die Anzahl der Gäste pro Tisch aus",
    statsDetails: {
      totalTables: "Anzahl der Tische",
      confirmedGuests: "Bestätigte Gäste",
      averagePerTable: "Durchschnitt pro Tisch"
    },
    standardTables: "Standardtische",
    places: "Plätze",
    placesEach: "Plätze jeweils",
    childrenTable: "Kindertisch",
    teenTable: "Jugendtisch",
    emptyTable: "Leerer Tisch",
    noTables: "Keine Tische erstellt",
    noGuests: "Keine Gäste zu platzieren",
    dragAndDrop: "Drag & Drop zum Ändern der Platzierung",
    honorTableTooltip: "Tisch reserviert für Brautpaar, Trauzeugen und enge Familie",
    childrenTableTooltip: "Tisch reserviert für Kinder von 0 bis 12 Jahren",
    teenTableTooltip: "Tisch reserviert für Jugendliche von 13 bis 17 Jahren",
    capacityTooltip: "Anzahl der Sitzplätze an diesem Tisch",
    editTable: "Tisch bearbeiten",
    deleteTable: "Tisch löschen",
    addTable: "Tisch hinzufügen",
    moveGuest: "Gast verschieben",
    filterByTable: "Nach Tisch filtern",
    filterByStatus: "Nach Status filtern",
    showUnassigned: "Nicht zugewiesene Gäste anzeigen",
    print: "Plan drucken",
    downloadPDF: "Als PDF herunterladen",
    confirmDelete: "Sind Sie sicher, dass Sie diesen Tisch löschen möchten?",
    confirmReset: "Sind Sie sicher, dass Sie den Sitzplan zurücksetzen möchten?",
    tableSaved: "Tisch erfolgreich gespeichert",
    tableDeleted: "Tisch erfolgreich gelöscht",
    guestMoved: "Gast erfolgreich verschoben",
    errors: {
      honorTableTooSmall: 'Der Ehrentisch ({{capacity}} Plätze) ist zu klein für alle VIPs ({{required}} Personen)',
      insufficientCapacity: 'Gesamtkapazität unzureichend ({{capacity}} Plätze) für {{guests}} Gäste'
    },
    autoTableCount: 'Geschätzte Anzahl Tische: {{tables}}',
    generationSummary: 'Plan generiert mit {{tables}} Tischen für {{guests}} Gäste (Gesamtkapazität: {{capacity}} Plätze)',
    guestDistribution: 'Verteilung nach Kategorie',
    sideDistribution: 'Verteilung nach Seite',
    statusDistribution: 'Verteilung nach Status',
    ageDistribution: 'Verteilung nach Alter',
    total: 'Gesamt',
    confirmedGuests: 'Bestätigte Gäste',
    honorTableHelp: 'Anzahl der Plätze am Ehrentisch (Brautpaar, Eltern, Trauzeugen)',
    standardTableHelp: 'Anzahl der Plätze an Standardtischen',
    honorTableSideHelp: 'Seite, die für den Ehrentisch bevorzugt wird',
    prioritizeFamilyHelp: 'Platziert die enge Familie bevorzugt am Ehrentisch',
    keepGroupsTogetherHelp: 'Versucht, Gästegruppen am selben Tisch zu halten',
    balanceTablesHelp: 'Gleicht die Anzahl der Gäste und ihre Verteilung an jedem Tisch aus',
    separateConflictsHelp: 'Vermeidet es, Gäste im Konflikt am selben Tisch zu platzieren',
    planName: "Planname",
    editPlanName: "Namen ändern",
    planNamePlaceholder: "Name des Sitzplans",
    savedSuccessfully: "Sitzplan erfolgreich gespeichert",
    loadExisting: "Vorhandenen Plan laden",
  },

  tableAssigned: "Tisch {{number}}",
  unnamed: "Unbenannt",
  ageGroup: "Altersgruppe",
  categoryOptions: {
    bride_groom: "Brautpaar",
    family_close: "Enge Familie",
    family_extended: "Erweiterte Familie",
    witness: "Trauzeuge",
    honor_party: "Ehrengäste",
    friend_close: "Enger Freund",
    friend: "Freund",
    colleague: "Kollege",
    acquaintance: "Bekannter",
    other: "Sonstige"
  },
  ageGroupOptions: {
    child: "Kind",
    teen: "Jugendlicher",
    adult: "Erwachsener",
    senior: "Senior",
    ageRange: {
      adult: "(18-64 Jahre)",
      senior: "(65+ Jahre)"
    }
  },
  vip: "VIP",

  bulkActions: {
    selectMultiple: 'Mehrfachauswahl',
    exitSelection: 'Auswahl verlassen',
    selectedCount: '{{count}} Gast/Gäste ausgewählt',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle abwählen',
    markConfirmed: 'Als bestätigt markieren',
    markPending: 'Als ausstehend markieren',
    markDeclined: 'Als abgelehnt markieren',
    confirmStatusUpdate: 'Statusänderung bestätigen',
    confirmStatusUpdateMessage: 'Sind Sie sicher, dass Sie den Status von {{count}} Gast/Gästen auf "{{status}}" ändern möchten?',
    statusUpdateSuccess: 'Status für {{count}} Gast/Gäste aktualisiert',
    statusUpdateError: 'Fehler bei der Statusaktualisierung',
    selected: 'Ausgewählt',
    selectThis: 'Diesen Gast auswählen'
  },

  guests: {
    statusLabels: {
      pending: "Ausstehend",
      confirmed: "Bestätigt",
      declined: "Abgelehnt",
      invited: "Eingeladen",
      maybe: "Vielleicht",
      not_invited: "Nicht eingeladen"
    }
  },

  pagination: {
    showing: "Zeige {{from}} bis {{to}} von {{total}} Gästen",
    previous: "Zurück",
    next: "Weiter"
  },

  columns: {
    name: "Name",
    email: "E-Mail",
    category: "Kategorie",
    table: "Tisch",
    status: "Status",
    children: "Kinder",
    actions: "Aktionen",
    plusOne: "Begleitung",
    phone: "Telefon",
    group: "Gruppe",
  },

  table: {
    name: "Name",
    email: "E-Mail",
    phone: "Telefon",
    status: "Status",
    relation: "Beziehung",
    side: "Seite",
    children: "Kinder",
    actions: "Aktionen",
    headers: {
      name: 'Name',
      email: 'E-Mail',
      group: 'Gruppe',
      events: 'Veranstaltungen',
      plusOne: '+1',
      status: 'Status',
      actions: 'Aktionen',
    },
    noEmail: 'Keine E-Mail',
    noData: '-',
  },

  sharing: {
    share: "Teilen",
    title: "Gäste teilen",
    defaultMessage: "Ich habe Gäste mit Ihnen geteilt",
    recipientEmail: "Empfänger-E-Mail",
    emailPlaceholder: "Geben Sie die E-Mail des Empfängers ein",
    recipientName: "Empfängername",
    namePlaceholder: "Geben Sie den Namen des Empfängers ein",
    message: "Nachricht",
    messagePlaceholder: "Geben Sie Ihre Nachricht ein",
    accessLevel: "Zugriffsebene",
    readOnly: "Nur Lesen",
    edit: "Bearbeiten",
    success: "Einladung erfolgreich gesendet",
  },

  relation: {
    family: "Familie",
    friend: "Freund(in)",
    colleague: "Kollege/Kollegin",
    other: "Sonstige",
    parent: "Elternteil",
    sibling: "Geschwister",
    cousin: "Cousin(e)",
    uncleAunt: "Onkel/Tante",
    grandparent: "Großelternteil",
  },

  side: {
    hostA: "Gastgeber A",
    hostB: "Gastgeber B",
    both: "Beide",
    none: "Keiner",
    bride: "Braut",
    groom: "Bräutigam",
  },

  actions: {
    addGuest: 'Gast hinzufügen',
    editGuest: 'Gast bearbeiten',
    deleteGuest: 'Gast löschen',
    importGuests: 'Gäste importieren',
    exportGuests: 'Gäste exportieren',
    sendInvitation: 'Einladung senden',
    resendInvitation: 'Einladung erneut senden',
    import: 'Importieren',
    export: 'Exportieren',
    search: 'Suchen...',
    sendReminder: 'Erinnerung senden',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    createInvitation: 'Einladung erstellen',
    cancel: "Abbrechen",
    save: "Speichern",
    view: "Ansehen",
    filter: "Filtern"
  },

  messages: {
    guestAdded: 'Gast erfolgreich hinzugefügt',
    guestUpdated: 'Gast erfolgreich aktualisiert',
    guestDeleted: 'Gast erfolgreich gelöscht',
    guestsImported: 'Gäste erfolgreich importiert',
    guestsExported: 'Gäste erfolgreich exportiert',
    invitationSent: 'Einladung erfolgreich gesendet',
    noGuests: 'Keine Gäste',
    addFirstGuest: 'Fügen Sie Ihren ersten Gast hinzu',
    createSuccess: "Gast erfolgreich hinzugefügt",
    updateSuccess: "Gast erfolgreich aktualisiert",
    deleteSuccess: "Gast erfolgreich gelöscht",
    deleteConfirm: "Sind Sie sicher, dass Sie diesen Gast löschen möchten?",
    error: "Ein Fehler ist aufgetreten",
    reminderSent: 'Erinnerung erfolgreich gesendet',
    importSuccess: 'Import erfolgreich abgeschlossen',
    exportSuccess: 'Export erfolgreich abgeschlossen',
  },

  modal: {
    title: "Gast",
    guestDetails: "Gästedetails",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    status: "Status",
    category: "Kategorie",
    side: "Seite",
    ageGroup: "Altersgruppe",
    plusOne: "Begleitung",
    plusOneFirstName: "Vorname der Begleitung",
    plusOneLastName: "Nachname der Begleitung",
    dietaryRestrictions: "Ernährungseinschränkungen",
    dietaryRestrictionsPlaceholder: "Vegetarier, Allergien...",
    notes: "Notizen",
    childrenCount: "Anzahl der Kinder (0-12 Jahre)",
    teenCount: "Anzahl der Jugendlichen (13-17 Jahre)",
    personalInfo: "Persönliche Informationen",
    accompaniment: "Begleitung und Kinder",
    children: "Kinder",
    relation: "Beziehung",
    attendance: "Anwesenheit",
    confirmDelete: "Sind Sie sicher, dass Sie diesen Gast löschen möchten?",
    categoryOptions: {
      bride_groom: "Brautpaar",
      family_close: "Enge Familie",
      family_extended: "Erweiterte Familie",
      witness: "Trauzeuge",
      honor_party: "Ehrengäste",
      friend_close: "Enger Freund",
      friend: "Freund",
      colleague: "Kollege",
      acquaintance: "Bekannter",
      other: "Sonstige"
    },
    relationOptions: {
      parent: "Elternteil",
      sibling: "Geschwister",
      cousin: "Cousin(e)",
      friend: "Freund(in)",
      colleague: "Kollege/Kollegin",
      other: "Sonstige"
    },
    sideOptions: {
      bride: "Braut",
      groom: "Bräutigam",
      both: "Beide",
      none: "Keiner"
    },
    statusOptions: {
      pending: "Ausstehend",
      confirmed: "Bestätigt",
      declined: "Abgelehnt"
    },
    ageGroupOptions: {
      adult: "Erwachsener",
      senior: "Senior",
      ageRange: {
        adult: "(18-64 Jahre)",
        senior: "(65+ Jahre)"
      }
    },
    confirm: 'Bestätigen',
    decline: 'Ablehnen',
    specialRequirements: "Besondere Anforderungen",
    specialNeeds: "Besondere Bedürfnisse",
    specialNeedsPlaceholder: "Barrierefreiheit, besondere Bedürfnisse...",
    seatingPlanParams: "Sitzplan-Parameter",
    selectCategory: "Kategorie auswählen",
    selectRelation: "Beziehung auswählen",
    selectSide: "Seite auswählen",
    selectAgeGroup: "Altersgruppe auswählen",
    noEmail: "Keine E-Mail",
    close: "Schließen",
    successDescription: "Erfolgreich geteilt",
    error: "Fehler",
    tableAssigned: "Tisch {{number}}",
    unnamed: "Unbenannt",
    vip: "VIP"
  },

  errors: {
    loadWedding: "Fehler beim Laden der Hochzeitsdaten",
    loadGuests: "Fehler beim Laden der Gäste",
    noWeddingFound: "Keine Hochzeit gefunden",
    generateSeatingPlan: "Fehler bei der Generierung des Sitzplans",
    saveSeatingPlan: "Fehler beim Speichern des Sitzplans",
    addGuest: 'Fehler beim Hinzufügen des Gastes',
    updateGuest: 'Fehler beim Bearbeiten des Gastes',
    deleteGuest: 'Fehler beim Löschen des Gastes',
    sendReminder: 'Fehler beim Senden der Erinnerung',
    import: 'Fehler beim Importieren',
    export: 'Fehler beim Exportieren',
  },

  fields: {
    firstName: 'Vorname',
    lastName: 'Nachname',
    status: 'Status',
    category: 'Kategorie',
    relation: 'Beziehung',
    side: 'Seite',
  },

  category: {
    family: 'Familie',
    friend: 'Freund',
    colleague: 'Kollege',
    other: 'Sonstige',
  },

  guestsWidget: {
    title: "Gäste",
    subtitle: "Gäste verwalten",
    total: "Gesamt",
    confirmed: "Bestätigt",
    pending: "Ausstehend",
    declined: "Abgelehnt",
    manage: "Gäste verwalten",
    empty: "Keine Gäste",
    addGuest: "Gast hinzufügen"
  },

  validation: {
    required: {
      lastName: "Nachname ist erforderlich",
      firstName: "Vorname ist erforderlich"
    },
    invalid: {
      email: "Ungültige E-Mail"
    }
  },

  stats: {
    title: 'Statistiken',
    label: 'Gästestatistiken',
    total: 'Gesamtgäste',
    confirmed: 'Bestätigt',
    pending: 'Ausstehend',
    declined: 'Abgelehnt',
    responseRate: 'Rückmeldequote',
  },

  empty: {
    noGuests: {
      title: 'Keine Gäste',
      description: 'Beginnen Sie mit dem Hinzufügen Ihres ersten Gastes.',
    },
    noResults: {
      title: 'Keine Gäste entsprechen den Filtern',
      description: 'Ändern Sie Ihre Filter, um mehr Ergebnisse zu sehen.',
    }
  },
  analytics: {
    title: "Gäste-Statistiken",
    totalGuests: "Gesamte Gäste",
    confirmationRate: "Bestätigungsrate",
    adultsVsMinors: "Erwachsene vs Minderjährige",
    rsvpStatus: "RSVP-Status",
    demographics: "Demografie",
    guestTypes: "Gästeaufteilung"
  },
  settings: {
    rsvpSettings: "RSVP-Einstellungen"
  }
};
